export * from './auth-guard';
export * from './authentication.service';
export * from './menu.service';
export * from './router.service';
export * from './module-loader.service';
export * from './dashboard.service';
export * from './theme.service';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/services/index.ts